import { render, staticRenderFns } from "./perekaman_tunggal.vue?vue&type=template&id=6f9ca6a1&"
import script from "./perekaman_tunggal.vue?vue&type=script&lang=js&"
export * from "./perekaman_tunggal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports